import React from 'react';
import { Grid } from '@material-ui/core';
import {
  string,
  node,
  objectOf,
  oneOfType,
  number,
} from 'prop-types';
import DefaultContainer from '../DefaultContainer';
import HeadlineSmall from '../HeadlineSmall';
import styles from './style.module.scss';

const SingleTextSection = ({
  children,
  className,
  style,
  textClassName,
  textStyle,
}) => (
  <DefaultContainer
    style={style}
    className={[styles.container, className].join(' ')}
    justify="center"
  >
    <Grid item sm={9} md={8}>
      <Grid item>
        <HeadlineSmall className={textClassName} style={{ marginBottom: '20px', textStyle }}>
        We App
        </HeadlineSmall>
      </Grid>
      <Grid item>
        <h2 className={styles.text}>{children}</h2>
      </Grid>
    </Grid>
  </DefaultContainer>
);

SingleTextSection.propTypes = {
  className: string,
  textClassName: string,
  children: node,
  style: objectOf(oneOfType([
    string,
    number,
  ])),
  textStyle: objectOf(oneOfType([
    string,
    number,
  ])),
};

SingleTextSection.defaultProps = {
  className: null,
  textClassName: null,
  children: null,
  style: null,
  textStyle: null,
};

export default SingleTextSection;
